import { ApolloClient, gql } from '@apollo/client/core';
import * as VPError from '../VPError';
import { ACCOUNT_AGNOSTIC } from '../api/accountContext';

type LoginResponse = {
  authToken: string;
  returnTo?: string;
  errors?: VPError.VPError[];
};

export const exchangeCognitoToken = async (client: ApolloClient<unknown>, accessToken: string, idToken?: string): Promise<LoginResponse> => {
  const { data } = await client.mutate({
    mutation: gql`
      mutation SignIn($accessToken: String!, $idToken: String) {
        signinUserMutation(input: { accessToken: $accessToken, idToken: $idToken }) {
          authToken
          returnTo
          errors {
            message
            path
          }
        }
      }
    `,
    variables: {
      accessToken,
      idToken,
    },
    // Account-agnostic: this is the request that establishes who the caller is. There is no
    // account to scope it to until it succeeds.
    context: ACCOUNT_AGNOSTIC,
  });

  return {
    authToken: data.signinUserMutation.authToken,
    returnTo: data.signinUserMutation.returnTo,
    errors: VPError.fromGqlCollection(data.signinUserMutation.errors),
  };
};
